import React from 'react';
import {string, array, func} from 'prop-types';
import styles from './mobileNavDrilldown.scss';
import classnames from 'classnames';
import ArrowLeft from 'dibs-vg/dist/react/arrow-left';
import MobileNavDrilldownList from './MobileNavDrilldownList';
import copy from './mobileNavDrilldownCopy';

export default function MobileNavDrilldown(props) {
    const {className, onItemClick, onBackClick} = props;
    const containerClass = classnames(styles.container, className);

    return (
        <div className={containerClass}>
            <div className={styles.back} onClick={onBackClick}>
                <ArrowLeft className={styles.backIcon} />
                <span>{copy.back}</span>
            </div>
            {props.sections.map(module => (
                <div key={module.name}>
                    <div className={styles.title}>{module.name}</div>
                    <MobileNavDrilldownList
                        key={module.name}
                        onItemClick={onItemClick}
                        items={module.items}
                    />
                </div>
            ))}
        </div>
    );
}

MobileNavDrilldown.propTypes = {
    className: string,
    onBackClick: func.isRequired,
    onItemClick: func.isRequired,
    sections: array.isRequired
};




// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldown.jsx